import React, { useState } from 'react';
import RichTextEditor from './RichTextEditor';

export default function BlockEditor({ initialContent, onSave, onCancel, saving = false }) {
  const [content, setContent] = useState(initialContent);
  return (
    <div className="inline-block-editor">
      <RichTextEditor initialContent={initialContent} onChange={setContent} ariaLabel="Edit saved block" />
      <div className="editor-actions">
        <button type="button" className="btn btn-primary" onClick={() => onSave(content)} disabled={saving}>{saving ? 'Saving…' : 'Save block'}</button>
        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={saving}>Cancel</button>
      </div>
    </div>
  );
}
